/**
 * Google Sheets Integration — FREE, no tools needed
 *
 * Sends form data directly to a Google Spreadsheet using Google Apps Script.
 *
 * ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 * SETUP (5 minutos, una sola vez):
 * ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * PASO 1: Crea un Google Sheet nuevo
 *   - Ve a https://sheets.google.com
 *   - Crea una hoja nueva llamada "Leads Pedro"
 *   - En la fila 1, escribe estos headers (exactamente así):
 *     A1: Fecha | B1: Nombre | C1: Teléfono | D1: Email | E1: Vehículo | F1: Crédito | G1: Idioma | H1: Fuente
 *
 * PASO 2: Abre el editor de Apps Script
 *   - En tu Google Sheet, ve a: Extensiones → Apps Script
 *   - Borra todo el código que aparece
 *   - Pega este código:
 *
 * ─────────────────────────────────────
 * function doPost(e) {
 *   try {
 *     var sheet = SpreadsheetApp.getActiveSpreadsheet().getActiveSheet();
 *     var data = JSON.parse(e.postData.contents);
 *
 *     sheet.appendRow([
 *       data.timestamp,
 *       data.name,
 *       data.phone,
 *       data.email,
 *       data.vehicle,
 *       data.creditScore,
 *       data.language,
 *       data.source
 *     ]);
 *
 *     return ContentService
 *       .createTextOutput(JSON.stringify({ status: 'ok' }))
 *       .setMimeType(ContentService.MimeType.JSON);
 *   } catch (error) {
 *     return ContentService
 *       .createTextOutput(JSON.stringify({ status: 'error', message: error.toString() }))
 *       .setMimeType(ContentService.MimeType.JSON);
 *   }
 * }
 * ─────────────────────────────────────
 *
 * PASO 3: Despliega como Web App
 *   - Haz clic en "Implementar" → "Nueva implementación"
 *   - Tipo: "Aplicación web"
 *   - Ejecutar como: "Yo" (tu cuenta)
 *   - Quién tiene acceso: "Cualquier persona"
 *   - Haz clic en "Implementar"
 *   - Copia la URL que te da (empieza con https://script.google.com/macros/s/...)
 *   - Pega esa URL abajo donde dice GOOGLE_SCRIPT_URL
 *
 * ¡LISTO! Cada lead aparecerá automáticamente en tu Google Sheet.
 * ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 */

// ⚠️ REEMPLAZA ESTO con tu URL de Google Apps Script
const GOOGLE_SCRIPT_URL =
  'https://script.google.com/macros/s/AKfycbx9VVQoYNnmVCL5In5xmaICQmeRwdPK_Br2tOvVfhTygMqUoyz6Gd3qWM0Dt7SxYRdc/exec'

export interface SheetLeadData {
  name: string
  phone: string
  email: string
  vehicle: string
  creditScore: string
  language: string
  source: string
  timestamp: string
}

/**
 * Sends lead data to Google Sheets via Apps Script
 * Non-blocking: won't prevent form submission if it fails
 */
export const sendToGoogleSheets = async (
  data: SheetLeadData,
): Promise<boolean> => {
  // Don't send if URL hasn't been configured
  if (GOOGLE_SCRIPT_URL.includes('YOUR_SCRIPT_ID_HERE')) {
    console.warn(
      '⚠️ Google Sheets URL not configured. Edit utils/googleSheets.ts and follow the setup instructions.',
    )
    return false
  }

  try {
    // Use no-cors mode since Google Apps Script doesn't return proper CORS headers
    // The data still gets saved, we just can't read the response
    await fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })

    console.log('✅ Lead enviado a Google Sheets')
    return true
  } catch (error) {
    console.error('❌ Error enviando a Google Sheets:', error)
    // Never block form submission
    return false
  }
}
